import type { AppState } from '../types';
import type { DisplaysState } from './types';

export const getSelectedDisplay = (state: AppState): DisplaysState['selectedDisplay'] =>
  state.displays.selectedDisplay;

export const getIsFullscreen = (state: AppState): DisplaysState['isFullscreen'] =>
  state.displays.isFullscreen;
